export enum Modules {
  /* parent module */
  DASHBOARD = "dashboard",
  USER_MANAGEMENT = "user-management",
  MASTER_MANAGEMENT = "master-management",
  WEB_USER_RESET_PASSWORD = "web-user-reset-password",
  USER_FEEDBACK = "user-feedback",
  ADVANCE_BOOKING_REQUEST_LIST = "advance-booking-request-list",
  ADVANCE_BOOKING_REQUEST_REPORT = "advance-booking-request-report",
  ABR_PENALTY_COLLECTION_REPORT = "abr-penalty-collection-report",

  /* child module */
  WEB_USER = "web-user",
  MOBILE_USER = "mobile-user",
  CONFIG_MASTER = "config-master",
  ROLE_MASTER = "role-master",
  MODULE_MASTER = "module-master",
  OPERATION_MASTER = "operation-master",
  WEB_FE_ACCESS_CONTROL_MASTER = "web-fe-access-control-master",
  USER_ROLE_MASTER = "user-role-master",
  CUSTOMER_MASTER = "customer-master",
  LOCATION_TYPE_MASTER = "location-type-master",
  PARKING_MAP_TYPE_MASTER = "parking-map-type-master",
  CUSTOMER_LOCATION_MASTER = "customer-location-master",
  CUSTOMER_CLIENT_MASTER = "customer-client-master",
  KEY_FOB_MASTER = "key-fob-master",
  KEY_FOB_ALLOCATION_MASTER = "key-fob-allocation-master",
  VEHICLE_TYPE_MASTER = "vehicle-type-master",
  ONGOING_LIST = "ongoing-list",
  SCHEDULE_LIST = "schedule-list",
  MANUAL_BOOKING_RETRIEVAL = "manual-booking-retrieval-request",
  EMERGENCY_RETRIEVAL_REQUEST = "emergency-retrieval-request",
  PARKING_OCCUPANCY_MONITORING = "parking-occupancy-monitoring",
  DEAD_PARKING_UPDATE = "dead-parking-update",
  PRICING_MASTER = "pricing-master",
  FAQ_MASTER = "faq-master",
  REQUEST_TYPE_MASTER = "request-type-master",
  PARKING_STATUS_MASTER = "parking-status-master",
  NOTIFICATION_MASTER = "notification-master",
  PARKING_HISTORY = "parking-history",
  MESSAGING = "messaging",
  SUPPORT_QUERY = "support-query",
  REQUEST_PER_HOUR_REPORT = "request-per-hour-report",
  VISITORS_REPORT = "visitors-report",
  ALL_USERS_PARKING_REPORT = "all-users-parking-report",
  PARKING_DATA_COUNTS_REPORT = "parking-data-counts-report",
  COMPLETE_ABR_REQUEST = "complete-abr-request",
  ADVANCE_BOOKING_QUOTA_MASTER = "advance-booking-quota-master"
}

export const ModuleAndIdMapping: Record<Modules, number> = {
  [Modules.DASHBOARD]: 0,
  [Modules.USER_MANAGEMENT]: 0,
  [Modules.MASTER_MANAGEMENT]: 0,
  [Modules.WEB_USER]: 0,
  [Modules.WEB_USER_RESET_PASSWORD]: 0,
  [Modules.MOBILE_USER]: 0,
  [Modules.CONFIG_MASTER]: 1,
  [Modules.ROLE_MASTER]: 2,
  [Modules.MODULE_MASTER]: 3,
  [Modules.OPERATION_MASTER]: 4,
  [Modules.WEB_FE_ACCESS_CONTROL_MASTER]: 5,
  [Modules.USER_ROLE_MASTER]: 6,
  [Modules.CUSTOMER_MASTER]: 7,
  [Modules.LOCATION_TYPE_MASTER]: 8,
  [Modules.PARKING_MAP_TYPE_MASTER]: 9,
  [Modules.CUSTOMER_LOCATION_MASTER]: 10,
  [Modules.CUSTOMER_CLIENT_MASTER]: 11,
  [Modules.KEY_FOB_MASTER]: 12,
  [Modules.KEY_FOB_ALLOCATION_MASTER]: 13,
  [Modules.VEHICLE_TYPE_MASTER]: 14,
  [Modules.PRICING_MASTER]: 15,
  [Modules.ONGOING_LIST]: 0,
  [Modules.ADVANCE_BOOKING_REQUEST_LIST]: 0,
  [Modules.PARKING_HISTORY]: 0,
  [Modules.SCHEDULE_LIST]: 0,
  [Modules.MANUAL_BOOKING_RETRIEVAL]: 0,
  [Modules.EMERGENCY_RETRIEVAL_REQUEST]: 0,
  [Modules.PARKING_OCCUPANCY_MONITORING]: 0,
  [Modules.DEAD_PARKING_UPDATE]: 0,
  [Modules.FAQ_MASTER]: 16,
  [Modules.REQUEST_TYPE_MASTER]: 17,
  [Modules.PARKING_STATUS_MASTER]: 18,
  [Modules.USER_FEEDBACK]: 0,
  [Modules.NOTIFICATION_MASTER]: 19,
  [Modules.MESSAGING]: 0,
  [Modules.SUPPORT_QUERY]: 0,
  [Modules.VISITORS_REPORT]: 0,
  [Modules.REQUEST_PER_HOUR_REPORT]: 0,
  [Modules.ALL_USERS_PARKING_REPORT]: 0,
  [Modules.PARKING_DATA_COUNTS_REPORT]: 0,
  [Modules.COMPLETE_ABR_REQUEST]: 0,
  [Modules.ADVANCE_BOOKING_QUOTA_MASTER]: 20,
  [Modules.ADVANCE_BOOKING_REQUEST_REPORT]: 0,
  [Modules.ABR_PENALTY_COLLECTION_REPORT]: 0
};

export enum Operations {
  CREATE = "create",
  READ = "read",
  UPDATE = "update",
  DELETE = "delete"
}

export const OperationAndIdMapping: Record<Operations, number> = {
  [Operations.CREATE]: 1,
  [Operations.READ]: 2,
  [Operations.UPDATE]: 3,
  [Operations.DELETE]: 4
};

export const enum Actions {
  ADD = "ADD",
  EDIT = "EDIT",
  DELETE = "DELETE"
}

export enum UserModuleAndIdMapping {
  WEB_USER = 1,
  MOBILE_USER = 2,
  VISITOR_USER = 3
}

export enum ConfigMasterConstants {
  MAX_KEY_FOB_RANGE = "MAX_KEY_FOB_RANGE",
  LOGO_IMAGE_PATH = "LOGO_IMAGE_PATH",
  HEADER_TEXT = "HEADER_TEXT",
  FOOTER_TEXT = "FOOTER_TEXT",
  PRIMARY_COLOR = "PRIMARY_COLOR",
  SECONDARY_COLOR = "SECONDARY_COLOR",
  DEFAULT_PAGE_SIZE = "DEFAULT_PAGE_SIZE",
  PAGE_SIZE_OPTIONS = "PAGE_SIZE_OPTIONS"
}

export enum UserTypeConstants {
  REGULAR = "REGULAR",
  VISITOR = "VISITOR"
}
